<template>
	<!-- carton管理 -->
	<div
	 :lang="$i18n.locale"
	 class="app-container">
	  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane :label="'库存列表'" name="first">
				<InventoryList :activeName="activeName"></InventoryList>
			</el-tab-pane>
	  </el-tabs>
	</div>
</template>

<script>
	import InventoryList from './inventoryList.vue'
	export default {
	  //import引入的组件需要注入到对象中才能使用
	  components: {
			InventoryList,
	  },
		data() {
		  //这里存放数据
		  return {
				activeName:'first',
				
			}
		},
		//方法集合
		methods: {
			handleClick(){
				
			}
			
		}
		
	}
</script>

<style scoped>
	.app-container {
		padding: 10px;
	}
</style>